module.exports = __webpack_public_path__ + "static/media/studentMedicalForm.5e6daca7.pdf";